import FormLabel from "components/Extra/FormLabel"
import React from "react"
import { FormFeedback, FormGroup, Input, InputProps, Label } from "reactstrap"
import { useFormik, FormikProps } from "formik"

interface FormInputProps extends InputProps {
  required?: boolean
  validation?: FormikProps<any>
  label?: string
  lightLabel?: string
  info?: string
}

export const FormInput: React.FC<FormInputProps> = ({
  required,
  validation,
  label,
  name,
  type,
  info,
  lightLabel,
  style,
  ...rest
}) => {
  if (!validation)
    return (
      <FormGroup>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-start gap-1">
            <Label
              className="form-label text-capitalize"
              htmlFor={name}
              required={required}
            >
              {label}
            </Label>
            <span>{lightLabel}</span>
          </div>
          {required && (
            <span className="text-danger fw-bold font-size-16">*</span>
          )}
        </div>
        <Input
          style={{
            boxShadow: "0px 2px 20px 0px #00000040",
            border: "1px solid #30303014",
            borderRadius: "8px",
            minHeight: "46px",
            ...style,
          }}
          id={name}
          name={name}
          type={type}
          {...rest}
        />
      </FormGroup>
    )

  return (
    <FormGroup>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-start gap-1">
          <Label
            className="form-label text-capitalize"
            htmlFor={name}
            required={required}
          >
            {label}
          </Label>
          <span>{lightLabel}</span>
        </div>
        {required && (
          <span className="text-danger fw-bold font-size-16">*</span>
        )}
      </div>
      <Input
        id={name}
        name={name}
        type={type}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        // @ts-ignore
        value={validation.values[name] || ""}
        invalid={
          // @ts-ignore
          validation.touched[name] && validation.errors[name] ? true : false
        }
        style={{
          boxShadow: "0px 2px 20px 0px #00000040",
          border: "1px solid #30303014",
          borderRadius: "8px",
          minHeight: "46px",
          ...style,
        }}
        {...rest}
      />
      {info && (
        <div className="d-flex align-items-center gap-1 ms-2">
          <i className="bx bx-info-circle"></i>
          <FormFeedback type="invalid" className="d-block text-secondary">
            {info}
          </FormFeedback>
        </div>
      )}
      {/* @ts-ignore */}
      {validation.touched[name] && validation.errors[name] ? (
        // @ts-ignore
        <FormFeedback type="invalid">{validation.errors[name]}</FormFeedback>
      ) : null}
    </FormGroup>
  )
}
